import {
  NewAPIResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import {
  normalizeVendorPaymentRow,
  VendorPaymentFormPayload,
  VendorPaymentRow,
} from "../models/PurchaseRequest/VendorPayments";
import { deleteAPI, getAPI, postAPI, putAPI } from "./Networking";

export default class VendorPaymentsAPI {
  getVendorPayments = async (
    prId?: number,
  ): Promise<PaginatedAPIResponse<VendorPaymentRow>> => {
    try {
      const response = await getAPI(
        "/v5/vendors/payments",
        prId ? { pr_id: prId } : undefined,
      );
      return response.result as PaginatedAPIResponse<VendorPaymentRow>;
    } catch (error) {
      throw error;
    }
  };

  getVendorPaymentById = async (id: number): Promise<VendorPaymentRow> => {
    try {
      const response = await getAPI(`/v5/vendors/payments/${id}`);
      return normalizeVendorPaymentRow(response.result);
    } catch (error) {
      throw error;
    }
  };

  createVendorPayment = async (payload: VendorPaymentFormPayload) => {
    try {
      const response = await postAPI("/v5/vendors/payments", payload);
      return response;
    } catch (error) {
      throw error;
    }
  };

  updateVendorPayment = async (
    id: number,
    payload: VendorPaymentFormPayload,
  ) => {
    try {
      const response = await putAPI(`/v5/vendors/payments/${id}`, payload);
      return response;
    } catch (error) {
      throw error;
    }
  };

  deleteVendorPayment = async (id: number) => {
    try {
      const response = await deleteAPI(`/v5/vendors/payments/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
}
